module.exports = __webpack_public_path__ + "media/whale sharks/iguana-d8f7ea67.jpg";